module.exports = __webpack_public_path__ + "static/media/fnl2.9856743b.mp4";